import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import { periverseTheme } from '@peritasai/ui-shared';
import { InactivityLogoutManager } from '../features/auth/inactivity';
import { TokenRefreshInvalidation } from './components/TokenRefreshInvalidation';
import {
  AuthProvider,
  QueryProvider,
  RouterProviderWrapper,
} from './providers';

LicenseInfo.setLicenseKey(
  '1b4223a692df7cf896b504fb9e2ecd74Tz0xMTkyODYsRT0xNzg5ODYyMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
);

export function App() {
  return (
    <ThemeProvider theme={periverseTheme}>
      <CssBaseline />
      <QueryProvider>
        <TokenRefreshInvalidation />
        <AuthProvider>
          <InactivityLogoutManager />
          <RouterProviderWrapper />
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}

export default App;
